import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { isEmbedded } from '@/lib/embed'

export default function PublicOnlyRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  // Login and register forms must never render inside a partner frame (clickjacking /
  // phishing): a framed visit to either is sent back to the dashboard, whose guard waits
  // for the parent's session.
  if (isEmbedded()) return <Navigate to="/" replace />

  return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />
}
